import React from "react";
import SavedAddress from "./Loadable";
import { SavedAddressWrapper } from "wrapper/SavedAddressWrapper";


export const SavedAddressPage = () => (
  <SavedAddressWrapper>
    <SavedAddress />
  </SavedAddressWrapper>
  );
